import { Component } from '@angular/core';
import { Game, GameModeEnum, IVocabularyStudyOptions, Vocabulary, VocabularyTerm } from 'lingo2-models';
import { OnUiButtonState } from 'onclass-ui';
import { takeUntil } from 'rxjs/operators';
import { BaseContentCard, IContentCardState } from '../base-content-card';
import { IVocabularyPlaymode } from './vocabulary-playmode/vocabulary-playmode.component';

interface IVocabularyCardComponentState extends IContentCardState {
  play: boolean;
  gameMode: GameModeEnum;
  playButton: OnUiButtonState;
  optionsOpen: boolean;
  playmodeOpen: boolean;
}

@Component({
  selector: 'app-vocabulary-card',
  templateUrl: './vocabulary-card.component.html',
  styleUrls: ['./vocabulary-card.component.scss'],
})
export class VocabularyCardComponent extends BaseContentCard {
  public state: IVocabularyCardComponentState = {
    ...super.getState(),
    play: false,
    gameMode: null,
    playButton: 'default',
    optionsOpen: false,
    playmodeOpen: false,
  };
  public studyOptions: IVocabularyStudyOptions;
  // public description: string;
  public isCutable: boolean;
  protected _item: Vocabulary;
  protected _game: Game;
  // protected cutMaxLength = 5;

  get game(): Game {
    return this._game;
  }

  protected init() {
    super.init();
    this.isCutable = this._item && (this._item.terms || []).length > this.cutMaxLength;
    this.detectChanges();

    if (this.isBrowser) {
      this.loadStudyOptions();
    }
  }

  protected loadStudyOptions() {
    this.vocabularyService
      .getVocabularyOptions(this._item.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (options) => {
          this.studyOptions = options;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public get terms(): VocabularyTerm[] {
    const terms = this._item.terms || [];
    return this.state.cut ? (terms.length > this.cutMaxLength ? terms.slice(0, this.cutMaxLength) : terms) : terms;
  }

  public get selectedTermsCount(): number {
    return this.studyOptions ? this.studyOptions.term_id.length : 0;
  }

  public showOptions() {
    this.state.optionsOpen = true;
    this.detectChanges();

    const terms = this._item.terms;
    if (terms && terms.length > 0 && !terms[0].definition) {
      this.contentService
        .getById(this._item.id, true)
        .pipe(takeUntil(this.destroyed$))
        .subscribe({
          next: (content) => {
            this._item = content as Vocabulary;
            this.detectChanges();
          },
          error: (error) => {
            this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
          },
        });
    }
  }

  public hideOptions() {
    this.state.optionsOpen = false;
    this.detectChanges();
  }

  public showPlaymode() {
    this.state.playmodeOpen = true;
    this.detectChanges();
  }

  public hidePlaymode() {
    this.state.playmodeOpen = false;
    this.detectChanges();
  }

  public onOptionsSelected(options: IVocabularyStudyOptions) {
    this.studyOptions = options;
    this.hideOptions();

    if (this.selectedTermsCount) {
      this.showPlaymode();
    }
  }

  public prepareGame(playmode: IVocabularyPlaymode) {
    this.hidePlaymode();
    this.state.playButton = 'progress';
    this.detectChanges();

    // @TODO: Получить от геймлиб апп данные про загрузку и поменять состояние кнопок

    // this.state.gameMode = GameModeEnum.single;
    // this.state.play = true;
    // this.state.playButton = 'done';
    // this.detectChanges();
    // this.resetButtonState('state.playButton');
    // this.setupMeta();
  }

  protected resetButtonState(button: string, timeout = 1500) {
    this.setTimeout(() => {
      this.state[button] = 'default';
      this.detectChanges();
    }, timeout);
  }

  public stopPlay() {
    this.state.play = false;
    this.resetMeta();
    this.detectChanges();

    this.contentService
      .getById(this._item.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (item) => {
          this.item = item as Vocabulary;

          if (this.selectedTermsCount) {
            this.showPlaymode();
          }

          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public trackByFn(index) {
    return index;
  }
}
